import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const LoginWithLink = () => {
    const [identifier, setIdentifier] = useState('');
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async e => {
        e.preventDefault();
        setErrors({});
        setSuccessMessage(null);
        setSubmitting(true);
        try {
            await axios.post('/api/v1/user/login-link', { identifier });
            setSuccessMessage('Check your email for a link to log in.');
        } catch (error) {
            if (error.response?.status === 404) {
                setErrors({ identifier: 'No account found with that username or email.' });
                return;
            }
            if (error.response?.status === 429) {
                setErrors({ other: error.response.data.error });
                return;
            }
            setErrors({ other: 'An error occurred while requesting a login link.' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <h2>Log In With Email Link</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-2">
                    <label htmlFor="identifier">Username or Email:</label>
                    <input type="text" id="identifier" name="identifier" className="form-control" value={identifier} onChange={e => setIdentifier(e.target.value)} />
                </div>
                {Object.keys(errors).length > 0 && (<div className="alert alert-danger">{Object.values(errors).join(', ')}</div>)}
                {successMessage && <div className="alert alert-success">{successMessage}</div>}
                <button className="btn btn-primary" type="submit" disabled={submitting}>{submitting ? 'Sending…' : 'Send login link'}</button>
                <div className="text-muted mt-4">
                    <Link to="/login">Back to sign in</Link>
                </div>
            </form>
        </div>
    );
};

export default LoginWithLink;
